export const DEFAULT_ALBUM_THUMBNAIL =
  "https://res.cloudinary.com/dz5nspe7f/image/upload/v1634653179/default-preset/WaveApp-vinyl-transparent_hrhl7p.png";

export const DEFAULT_PROFILE_PICTURE =
  "https://res.cloudinary.com/dz5nspe7f/image/upload/v1633334998/default-preset/default-profile-picture_vbob5l.png";

export const DEFAULT_PLAYLIST_THUMBNAIL =
  "https://res.cloudinary.com/dz5nspe7f/image/upload/v1634653179/default-preset/WaveApp-default-playlist-white_ayc9vb.png";
